export const OMNIALOG_ORDERS_API_URL = process.env.REACT_APP_OMNIALOG_ORDERS_API_URL || ''
export const OMNIALOG_USERS_API_URL = process.env.REACT_APP_OMNIALOG_USERS_API_URL
export const OMNIALOG_ASSETS_API_URL = process.env.REACT_APP_OMNIALOG_ASSETS_API_URL
export const OMNIALOG_CORE_API_URL = process.env.REACT_APP_OMNIALOG_CORES_API_URL || ''
export const OMNIALOG_PRODUCTS_API_URL = process.env.REACT_APP_OMNIALOG_PRODUCTS_API_URL || ''

export const REDIRECT_URL = process.env.REACT_APP_OMNIALOG_REDIRECT_URL
export const AUTHORITY = process.env.REACT_APP_OMNIALOG_AUTHORITY
export const AUTHORITY_DOMAIN = process.env.REACT_APP_OMNIALOG_AUTHORITY_DOMAIN || ''
export const CLIENT_ID = process.env.REACT_APP_OMNIALOG_CLIENT_ID || ''
export const AUTH_DISABLED = AUTHORITY === 'disabled'
export const TRANSPORT_FEATURE = process.env.REACT_APP_TRANSPORT_FEATURE === 'true'
export const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || 'error'
